import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-108" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-109" data-mp="1cf03nb26x4mz">
        <div className="text-center mb-16" data-id="element-110" data-mp="1cgb8le7dgifo">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-[#16191E] uppercase" data-id="element-111" data-mp="2a1ytb1ugtcbd">
            Frequently Asked <span className="text-[#E8590C]" data-id="element-112" data-mp="252w14hzl30kt">Questions</span>
          </h2>
        </div>
        <div className="space-y-4" data-id="element-113" data-mp="203jcpst2dlg4">
          {faqs.map((faq, index) => <div key={faq.q} className={`bg-white border rounded-xl overflow-hidden transition-colors duration-150 ease-out ${openIndex === index ? 'border-[#16191E]' : 'border-[#D5DAE0]'}`} data-id="element-114" data-mp="1v4zqrseh09nr" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-[#F3F5F7] transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#E8590C]" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-115" data-mp="jo9hu1inx3qg">
                <span className="font-bold text-lg text-[#16191E] pr-8" data-id="element-116" data-mp="11xil1fg1fjtm">{faq.q}</span>
                <ChevronDown className={`text-[#E8590C] transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-117" data-mp="16nyxoxc1b1ex" />
              </button>
              <AnimatePresence initial={false} data-id="element-118" data-mp="wyxih9dbco20">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-119" data-mp="izfq6k0t6snw">
                    <div className="px-6 pb-5 text-slate-700 border-t border-[#D5DAE0] pt-4 space-y-2" data-id="element-120" data-mp="2ku3qgxe2awua">
                      {faq.a.map(paragraph => <p key={paragraph} data-id="element-121" data-mp="2az20y0fvjsr6">{paragraph}</p>)}
                      {faq.list && <ul className="list-disc pl-5 grid sm:grid-cols-2 gap-x-4 gap-y-1" data-id="element-122" data-mp="38kpy4nk5mf3r">
                          {faq.list.map(item => <li key={item} data-id="element-123" data-mp="2ymsb23e16ocq">{item}</li>)}
                        </ul>}
                      {faq.afterList && <p data-id="element-124" data-mp="2ulgipq3rvp0u">{faq.afterList}</p>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}